module.exports = __webpack_public_path__ + "static/media/tianshangshan_package.329f79cd.webp";